<template>
  <NBox v-for="item in 4" :key="item" class="py-4 mb-4 px-3 space-y-2">
    <div class="flex flex-col gap-3 px-3">
      <TextSkeleton width="50%" />
      <TextSkeleton width="70%" />
    </div>
  </NBox>
</template>

<script setup lang="ts">
import TextSkeleton from '@/components/TextSkeleton.vue';
</script>
